<template>
  <div class="mod-joylearning__offringlist}">
    <div class="pkg-search-box">
      <el-form class="pkg-content" label-width="auto"
               label-position="left"
               :model="dataForm"
               @keyup.enter.native="getDataList()">
        <el-row class="margb10">
          <el-col :span="8">
            <el-form-item label="姓名" >
              <el-input v-model="dataForm.userName" clearable placeholder="请输入用户ID/姓名/员工号"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="评估职位">
              <el-select v-model="dataForm.jobId"
                         clearable
                         :placeholder="$t('user.select')">
                <el-option v-for="(item,index) in keyPositionArr"
                           :key="index"
                           :label="item.positionCode + '-' +item.positionName"
                           :value="item.positionId">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item >
            </el-form-item>
          </el-col>

          <el-col :span="3">
            <el-button class="M-search"
                       style="margin-bottom: 7px"
                       type="primary"
                       @click="getDataListMerge">{{$t('course.query')}}
            </el-button>
          </el-col>
        </el-row>
        <!-- ---->
        <el-row class="margb10">
          <el-col :span="21">
            <el-form-item >
            </el-form-item>
          </el-col>

          <el-col :span="3">
            <!-- 重置 -->
            <el-col :span="24">
              <el-button class="el-back M-search M-margin-l"
                         type="info"
                         @click="again">{{$t('reset')}}
              </el-button>
            </el-col>
          </el-col>
        </el-row>

      </el-form>
      <el-row style="text-align: center; margin-bottom: 10px;">
        <el-col :span="24">
          <div class="show-or-hide-icon">
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="pkg-content">
      <div v-show="false" style="float:right">
        <el-link type="primary" :underline="false"  @click="viewPolicyOK">同意被评估人查看本人能力评估报告《隐私政策》</el-link>
      </div>
      <!-- 表头动态展示 -->
      <el-table v-loading="dataListLoading"
                ref="multipleTable"
                :data="dataList"
                border
                :row-style="{height:48+'px'}"
                :cell-style="{padding:0+'px'}">
        <!--  用户ID  -->
        <el-table-column prop="userCode"
                         label="用户ID"
                         header-align="center"
                         align="center"
                         width="110"
                         :show-overflow-tooltip="true"
                         fixed></el-table-column>
        <!--员工号-->
        <el-table-column prop="userCardNo"
                         label="员工号"
                         header-align="center"
                         align="left"
                         :show-overflow-tooltip="true"
                         width="110"
                         fixed></el-table-column>

        <!--姓名-->
        <el-table-column label="姓名"
                         prop="userName"
                         header-align="left"
                         align="left"
                         :show-overflow-tooltip="true"
                         width="100"></el-table-column>
        <!-- 评估职位 -->
        <el-table-column prop="positionName"
                         label="评估职位"
                         header-align="left"
                         align="left"
                         width="100"
                         :show-overflow-tooltip="true">
        </el-table-column>
        <!-- 申请评测经销商 -->
        <el-table-column prop="dealerName"
                         label="申请评测经销商"
                         header-align="center"
                         align="center"
                         width="145"
                         :show-overflow-tooltip="true"
        ></el-table-column>
        <!-- 品牌 -->
        <el-table-column prop="brand"
                         label="品牌"
                         header-align="center"
                         width="80"
                         :show-overflow-tooltip="true"
                         align="center"></el-table-column>
        <el-table-column prop="brand"
                         label="品牌"
                         header-align="center"
                         width="80"
                         :show-overflow-tooltip="true"
                         align="center"></el-table-column>
        <!-- 网点类型 -->
        <el-table-column prop="netWorkType"
                         label="网点类型"
                         header-align="center"
                         width="100"
                         :show-overflow-tooltip="true"
                         align="center"></el-table-column>
        <!-- 申请测评时间 -->
        <el-table-column prop="recruitmentTime"
                         label="申请测评时间"
                         header-align="left"
                         align="left"
                         :show-overflow-tooltip="true"
        ></el-table-column>
        <!-- 能力评估状态 -->
        <el-table-column prop="assessmentStatus"
                         label="能力评估状态"
                         header-align="left"
                         align="left"
                         :show-overflow-tooltip="true"
        ></el-table-column>
        <!-- 评估中心结果 -->
        <el-table-column prop="result"
                         label="评估中心结果"
                         header-align="left"
                         align="left"
                         :show-overflow-tooltip="true"
        ></el-table-column>
        <!--能力评估报告 -->
        <el-table-column label="操作"
                         fixed="right"
                         header-align="center"
                         align="center"
                         width="140">
          <template slot-scope="scope">
            <div>

              <el-dropdown trigger="click"
                           placement="bottom">

                  <span class="el-dropdown-link">
                    {{ $t('offering.more') }}<em class="el-icon-caret-bottom el-icon--right"></em>
                  </span>
                <el-dropdown-menu slot="dropdown" style="width: auto">
                  <el-dropdown-item :disabled="scope.row.reportName === ''" @click.native="expertEvaluationDow(scope.$index)">
                    下载评估报告
                  </el-dropdown-item>
                  <el-dropdown-item v-if="scope.row.viewReport === '0'" @click.native="viewPolicy(scope.row.recruitmentId)">
                    授权评估报告
                  </el-dropdown-item>
                  <el-dropdown-item v-if="scope.row.viewReport === '1'" @click.native="cancelViewPolicy(scope.row.recruitmentId)">
                    取消授权评估报告
                  </el-dropdown-item>
                  <el-dropdown-item v-if="$hasPermission('ACDC0001002')&&scope.row.personalityExamTaskId" @click.native="goCharacter(scope.row)">
                    {{ $t('assessment.checkCharacter') }}
                  </el-dropdown-item>
                  <el-dropdown-item v-if="$hasPermission('ACDC0001002')&&scope.row.scenarioExamTaskId" @click.native="goSence(scope.row)">
                    {{ $t('assessment.checkSence') }}
                  </el-dropdown-item>
                  <el-dropdown-item v-if="$hasPermission('ACDC0001002')&&scope.row.interviewId" @click.native="goArea(scope.row)">
                    {{ $t('assessment.checkArea') }}
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination :current-page="page"
                     :page-sizes="[10, 20, 50, 100]"
                     :page-size="limit"
                     :total="total"
                     layout="total, sizes, prev, pager, next, jumper"
                     @size-change="pageSizeChangeHandle"
                     @current-change="pageCurrentChangeHandle">
      </el-pagination>
    </div>

    <!-- 弹窗, 政策 -->
    <assessmentDetailPolicy @func="assessmentDetailEmit"
                            ref="refAssessmentDetailPolicy"></assessmentDetailPolicy>

    <!-- 弹窗, 政策 确定按钮 -->
    <assessmentDetailPolicyOK @func="assessmentDetailEmitOK"
                              ref="refAssessmentDetailPolicyOK"></assessmentDetailPolicyOK>
    <!-- 查看反馈 -->
    <el-dialog title="查看区域反馈" :visible.sync="dialogTableVisible" class="dialogTableClass assessement-report-dialog" width="60%"
               :before-close="handleClose">
      <div class="assessment-result clearfix">
        <span class="areainfo-userinfo-module areainfo-userinfo-module1">{{ userInfo.userName }}</span>
        <span class="areainfo-userinfo-module">用户ID： {{ userInfo.userCode }}</span>
        <span class="areainfo-userinfo-module">员工号：{{ userInfo.userCardNo }}</span>
        <span class="areainfo-userinfo-module">经销商：{{ userInfo.dealerName }}</span>
        <span class="areainfo-userinfo-module">评估职位：{{ userInfo.recruitmentPosition }}</span>
      </div>
      <el-form ref="ruleForm" :model="areaInfo" label-width="left" size="medium "
               class="assessment-form" enctype="multipart/form-data">
        <p class="assessment-form-label">
          <span style="color:red;">*</span>是否推荐候选人参加能力评估？请提供理由
        </p>
        <el-form-item prop="interviewResult" style="margin-bottom:20px !important;">
          <el-radio-group v-model="areaInfo.status" size="medium" label-width="left">
            <el-radio :label="'Pass'" :disabled="areaInfo.status==='Failed'">推荐</el-radio>
            <el-radio :label="'Failed'" :disabled="areaInfo.status==='Pass'">不推荐</el-radio>
          </el-radio-group>
        </el-form-item>
             <el-form-item prop="remark" style="width:100% !important;">
          <el-input type="textarea" v-model.trim="areaInfo.remarks" min="50" max="500" :rows="5"
                    placeholder="请填写推荐/不推荐理由（50~500字符）"
                    disabled="true" maxlength="500"></el-input>
          <span style="float: right;">{{ areaInfo.remarks.trim() ? areaInfo.remarks.trim().length : 0 }}/500</span>
        </el-form-item>
        <el-form-item style="width:100% !important;margin-top:20px;">
          <el-col :span="9" :offset="15" style="text-align:right;">
            <el-button type="primary" @click="dialogTableVisible = false">确 认</el-button>
            <el-button @click="dialogTableVisible = false">取 消</el-button>
          </el-col>
        </el-form-item>
      </el-form>
      <div style="height: 20px;"></div>
    </el-dialog>
  </div>
</template>

<script>
import mixinViewModule from '@/mixins/view-module'
import assessmentDetailPolicy from "../assessment/assessmentDetailPolicy";
import assessmentDetailPolicyOK from "../assessment/assessmentDetailPolicyOK";

export default {
  mixins: [mixinViewModule],
  components: {
    assessmentDetailPolicy: assessmentDetailPolicy,
    assessmentDetailPolicyOK: assessmentDetailPolicyOK
  },
  data() {
    let _this = this
    return {
      mixinViewModuleOptions: {
        getDataListURL: '/acdc/recruitment/queryRecruitmentReportByPage',
        getDataListIsPage: true,
      },
      keyPositionArr:[], // 职位
      dataForm: {
        jobId:'',//职位id
        userName:'',//用户
      },
      clickItemrRecruitmentId:'', //当前行的recruitmentid
      dialogTableVisible: false,
      userInfo: {
        userName: '',
        userCode: '',
        userCardNo: '',
        dealerName: '',
        recruitmentPosition: ''
      },
      areaInfo: {
        status: '',
        remarks: ''
      }
    }
  },
  created() {
    this.init()
  },
  methods: {
    // 页面初始化
    init() {
      // 职位
      this.$request
        .get('/sys/commposition/keyPosition')
        .then((res, total, code, data) => {
          this.keyPositionArr = data.data
        })
        .catch((err) => {
          console.log(err)
        })
      if (this.$hasPermission('ACDC0000001')) {
        this.dataForm.roleType = 'acdcAdmin'
      }
    },
    // 查询
    getDataListMerge() {
      this.page = 1
      this.getDataList()
      if (this.$hasPermission('ACDC0000001')) {
        this.dataForm.roleType = 'acdcAdmin'
      }
    },
    // 重置
    again() {
      this.dataForm.jobId = ''
      this.dataForm.userName = ''
      this.page = 1
      this.getDataList()
      if (this.$hasPermission('ACDC0000001')) {
        this.dataForm.roleType = 'acdcAdmin'
      }
    },
    // 弹出确定的政策
    viewPolicyOK() {
      this.$refs.refAssessmentDetailPolicyOK.init()
    },
    // 政策回掉
    assessmentDetailEmit(data) {
      console.log('政策回掉')
      console.log(this.clickItemrRecruitmentId)
      //TODO--- 调用确定协议接口 1,勾选 0：取消勾选
      this.authViewReport('1',this.clickItemrRecruitmentId)
    },
    // 政策回掉 确定
    assessmentDetailEmitOK(data) {
      // this.assessDetailchecked = data
    },

    // 弹出确定的政策_ 倒计时10秒
    viewPolicy(recruitmentId) {
      this.clickItemrRecruitmentId = recruitmentId
      this.$refs.refAssessmentDetailPolicy.init()
    },
    // 取消授权
    cancelViewPolicy(recruitmentId){
      // 1,勾选 0：取消勾选
      this.authViewReport('0',recruitmentId)

    },
    // 调用保存政策状态方法
    authViewReport(viewReport,recruitmentId) {
      this.$request.post('/acdc/recruitment/authViewReport', {
        id: recruitmentId,
        viewReport: viewReport
      }).then((res, total, code, data) => {
        if(viewReport === '1'){
          this.$message.success('授权成功')
        }
        if(viewReport === '0'){
          this.$message.info('去掉勾选后，候选人将无法查看本人能力评估报告')
        }
        this.getDataList()
      }).catch((err) => {
        console.log(err)
      })
    },
    // 在线测评附件下载
    expertEvaluationDow(index) {
      console.log('experEvaluatonDow ')
      this.$request.downloadLearning('/acdc/fileManagement/downloadFile',
        this.dataList[index].reportName,
        {
          recruitmentId: this.dataList[index].recruitmentId,
        },
        null,
        true
      )
    },
    // 分页, 每页条数
    pageSizeChangeHandle (val) {
      this.page = 1
      this.limit = val
      this.getDataList()
    },
    // 分页, 当前页
    pageCurrentChangeHandle (val) {
      this.page = val
      this.getDataList()
    },
    // 跳转性格测试
    goCharacter (val) {
      this.$router.push({
        name: 'acdc-report-natureReport',
        query: {
          bizId: val.recruitmentId,
          bizType: val.personalityExamTaskId
        }
      })
    },
    // 跳转情景测试
    goSence (val) {
      this.$router.push({
        name: 'acdc-report-sceneReport',
        query: {
          bizId: val.recruitmentId,
          bizType: val.scenarioExamTaskId
        }
      })
    },
    goArea (val) {
      let roleType = ''
      if (this.$hasPermission('ACDC0000001')) {
        roleType = 'acdcAdmin'
      } else if (this.$hasPermission('ACDC0000002')) {
        roleType = 'areaManager'
      }
      const params = {
        recruitmentId: val.recruitmentId,
        recruitmentPosition: val.positionName,
        roleType: roleType,
        userCode: val.userCode
      }
      this.$request.post('/acdc/recruitment/queryRecruitmentDetail', params)
      .then((res, total, code, data) => {
        this.userInfo = data.data.userInfo
        this.areaInfo = data.data.regionalFeedBack
        this.dialogTableVisible = true
      })
      .catch((err) => {
        console.log(err)
      })
    },
    handleClose () {
      this.dialogTableVisible = false
    }
  }
}
</script>
<style lang="scss" scoped>
@import "../../../css/pkg-styles.css";

.aui-wrapper .el-date-editor .el-range-separator {
  width: 30px;
}

.jieshu .el-form-item__content {
  width: 94.5%;
}

.kaishi .el-form-item__content {
  width: 111%;
}

.el-row {
  margin-bottom: 0px;
}

#container {
  display: -webkit-flex;
}

.el-date-editor.el-input {
  width: 150px;
}

.search-item {
  width: 94% !important;
  min-width: 290px;
}

.search {
  height: 50px;
}

.wrapper-div {
  .el-dialog__title {
    text-align: center;
    display: block;
  }
}

.grid-content {
  border-radius: 4px;
  min-height: 36px;
}

 .search-item .el-form-item__content {
  margin-left: 96px !important;
}
.el-dropdown-menu__item.is-disabled {
  cursor: default;
  color: #bbb;
  pointer-events: none;
}
.dialogTableClass{
  .el-divider--horizontal{
    display: block;
    height: 1px;
    width: 100%;
    margin: -24px 0;
  }
}
.assessment-result {
  height: 32px;
  line-height: 32px;
  margin-bottom: 20px;
  .areainfo-userinfo-module{
    display: inline-block;
    margin-right: 20px;
    height: 100%;
    &.areainfo-userinfo-module1{
      font-size: 20px;
      font-weight: bold;
    }
  }
}
.divDialog{
  .el-divider--horizontal {
    display: block;
    height: 1px;
    width: 100%;
    margin: 1px 0;
  }
}
</style>
<style lang="scss">
.assessement-report-dialog {
  .assessment-form-label{
    margin-bottom: 20px !important;
  }
}
</style>
